/**
 * Feature gates Mixpanel lus par l'app (projet de l'environnement : Smart
 * Offers – Dev hors production, projet de prod sur `deals.appchoose.io`).
 *
 * Ajouter une clé ici avant de la lire avec `getFeatureFlag` /
 * `getFeatureFlagSync` (`lib/mixpanel.ts`) : la clé doit exister, avec le même
 * nom, dans chaque projet Mixpanel concerné.
 */
export const FEATURE_FLAGS = {
  /** Parcours Smart Offers interne en cours de déploiement. */
  smartOfferRedesign: 'smart-offer-redesign',
  /** Transport temps réel des offres : `On` → SSE, sinon WebSocket. */
  dealRealtimeSse: 'stream',
} as const;

export type FeatureFlagKey = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
